import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { BackArrowIcon } from '../../icon/icon';

interface JoinHeaderProps {
  menuTitle: string;
}

const JoinHeader = ({ menuTitle }: JoinHeaderProps) => {
  const history = useHistory();
  const backBtn = () => {
    history.goBack();
  };

  return (
    <HeaderContainer>
      <div onClick={backBtn}>
        <BackArrowIcon />
      </div>
      <div className="title">
        <span>{menuTitle}</span>
      </div>
    </HeaderContainer>
  );
};

export default JoinHeader;

//style
const HeaderContainer = styled.header`
  display: flex;
  position: relative;
  padding: 1.1rem 0.4rem;
  .title {
    font-size: 1.6rem;
    font-weight: 600;
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;
